import Api from "@/repository/api";
import {ResponseDataType} from "@/form/form.types";
import {IPartnerRepository} from "@/repository/partner/PartnerRepository.types";
import {IPartner, PartnerResponseType} from "@/entity/partner/partner.types";
import Partner from "@/entity/partner/partner";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import qs from "qs";

export class PartnerRepository implements IPartnerRepository {
    async fetchAll(data?: PaginationRequestType): Promise<IPartner[]> {
        const resp = await Api.get('/partner/get', { params: data, paramsSerializer: function paramsSerializer(params) {
            return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const respData = resp.data as PartnerResponseType[];
        return respData.map((partner: PartnerResponseType) => new Partner(partner));
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const resp = await Api.post('/partner/delete', data);
        return resp.data;
    }
}